import { HttpClient, HttpParams } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { ConfigurationService } from '@pflegix/config';
import { GlobalSearchModel, IGlobalSearchModelResult } from '@pflegix/types';
import { catchError, Observable, of } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class GlobalSearchApi {
  private readonly httpClient = inject(HttpClient);
  private readonly configurationService = inject(ConfigurationService);

  /**
   * Returns the API URL for global search.
   * @returns The API URL for global search.
   */
  private get apiUrl(): string {
    return `${this.configurationService.get('basePflegixApiUrl')}/api/global-search`;
  }

  /**
   * Returns the customers that match the given filter.
   *
   * @param filter The filter to apply.
   * @param models The models to include in the search.
   * @returns An Observable that resolves to the customers that match the given filter.
   */
  public getCustomersByFilter(
    filter: string,
    models: GlobalSearchModel[] = []
  ): Observable<IGlobalSearchModelResult[]> {
    let params = new HttpParams().set('filter', filter);

    if (models.length) {
      params = params.set('models', models.join(','));
    }

    return this.httpClient.get<IGlobalSearchModelResult[]>(`${this.apiUrl}`, { params }).pipe(catchError(() => of([])));
  }
}
